module.exports = {"421202001":"温泉","421202002":"浮山","421202003":"永安","421202100":"汀泗桥镇","421202101":"向阳湖镇","421202102":"官埠桥镇","421202103":"横沟桥镇","421202104":"贺胜桥镇","421202105":"双溪桥镇","421202106":"马桥镇","421202107":"桂花镇","421202108":"高桥镇","421202200":"大幕乡","421202450":"向阳湖奶牛良种场","421202570":"咸宁市经济技术开发区","421202571":"湖北咸安经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421202.json
// module id = 1783
// module chunks = 0